import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../../icons/logo";
import ChartIcon from "../../../icons/chartIcon";
import ContainerTruckIcon from "../../../icons/containerTruckIcon";
import CommentIcon from "../../../icons/commentIcon";
import BellIcon from "../../../icons/bellIcon";
import SettingsIcon from "../../../icons/settingsIcon";
import OfferPriceIcon from "../../../icons/offerPriceIcon";

const EmployeesSideBar = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const links = [
    { path: "/employee/dashboard", label: t("home"), Icon: ChartIcon },
    {
      path: "/employee/dashboard/shipments",
      label: t("Shipments"),
      Icon: ContainerTruckIcon,
    },
    {
      path: "/employee/dashboard/offer-price",
      label: t("Offer Price"),
      Icon: OfferPriceIcon,
    },
    {
      path: "/employee/dashboard/request-replies",
      label: t("Request Replies"),
      Icon: CommentIcon,
    },
    {
      path: "/employee/dashboard/notifications",
      label: t("Notifications"),
      Icon: BellIcon,
    },
    { path: "/employee/dashboard/settings", label: t("settings"), Icon: SettingsIcon },
  ];

  return (
    <aside className="sticky top-0 ">
      <Link
        to={"/"}
        className="bg-[#E5EDFF] w-64 flex items-center py-4 justify-center"
      >
        <Logo />
      </Link>
      <div className="flex flex-col gap-5 p-8 capitalize">
        {links.map(({ path, label, Icon }) => (
          <Link
            key={path}
            to={path}
            className={`flex items-center gap-2  font-medium ${
              pathname === path ? "text-mainBlue" : "text-mainGray hover:text-black"
            }`}
          >
            <span>
              <Icon fill={pathname === path ? "#0051FF" : ""} />
            </span>
            <span className="-mb-[3px]">{label}</span>
          </Link>
        ))}
      </div>
    </aside>
  );
};

export default EmployeesSideBar;
